import React, { useState } from "react";
import { injectIntl } from "react-intl";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import { useMutation } from "@apollo/client";
import { Container } from "react-bootstrap";

import Loader from "../../components/Common/Loader/Loader";
import showToaster from "../../helpers/toastrMessgaes/showToaster";
import { deleteAccount as deleteAccountMutation } from "../../lib/graphql";
import history from "../../history";
import messages from "../../locale/messages";
import bt from '../../components/commonStyle.css';
import s from "./DeleteAccount.css";

// COMPLIANCE: client self-service account deletion (Apple/Google requirement). On success the session
// is ended via the server /logout route (clears the httpOnly id_token cookie).
const DeleteAccount = (props) => {
    const { intl: { formatMessage } } = props;
    const [deleteAccount] = useMutation(deleteAccountMutation);
    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        if (typeof window !== 'undefined' && !window.confirm(formatMessage(messages.deleteAccountConfirm))) {
            return;
        }
        if (typeof navigator !== 'undefined' && !navigator.onLine) {
            showToaster({ messageId: 'networkFailed', toasterType: 'error' });
            return;
        }
        setDeleting(true);
        try {
            const { data } = await deleteAccount();
            if (data?.deleteAccount?.status === 200) {
                showToaster({ messageId: 'errorMessage', requestContent: formatMessage(messages.accountDeleted), toasterType: 'success' });
                // End the session (clears the httpOnly cookie server-side) and leave the app.
                if (typeof window !== 'undefined') {
                    window.location.assign('/logout');
                } else {
                    history.push('/');
                }
            } else {
                setDeleting(false);
                showToaster({ messageId: 'errorMessage', requestContent: data?.deleteAccount?.errorMessage, toasterType: 'error' });
            }
        } catch (error) {
            setDeleting(false);
            showToaster({ messageId: 'errorMessage', requestContent: error?.message, toasterType: 'error' });
        }
    };

    return (
        <div className={cx('subPageContainer')}>
            <Container>
                <div className='subPageWrapper'>
                    <p className={s.pageTitle}>{formatMessage(messages.deleteAccount)}</p>
                    <div className={s.warningCard}>
                        <p className={s.warningTitle}>{formatMessage(messages.deleteAccountWarningTitle)}</p>
                        <p className={s.warningText}>{formatMessage(messages.deleteAccountWarningText)}</p>
                        <div className={s.btnRow}>
                            <Loader
                                type={"button"}
                                buttonType={"button"}
                                show={deleting}
                                label={formatMessage(messages.deleteAccountButton)}
                                className={cx(bt.btnPrimary, s.deleteBtn, 'loaderButtonFlex')}
                                handleClick={handleDelete}
                            />
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default injectIntl(withStyles(bt, s)(DeleteAccount));
